export enum Role {

  APPLICANT,
  COORDINATOR,
  BOARD_MEMBER,
  NONE
}
